// extracted by mini-css-extract-plugin
export default {"FinanceTable":"FinanceTable_FinanceTable__cTmbn","header":"FinanceTable_header__bRlRn","brandCard":"FinanceTable_brandCard__99ywR","titleStyle":"FinanceTable_titleStyle__hI+wO"};